import React from 'react';

import { MdDelete as DeleteIcon } from 'react-icons/md';
import IconButton from 'material-ui/IconButton';
import { stringArraySort } from 'helpers/StringHelper';

const TenantDocumentList = ({ documents, deleteTenantDocument }) => {
  return (
    <div className="row">
      <h4 style={{ fontSize: '18px', marginBottom: 0 }}> Documents </h4>

      {documents && documents.length ? (
        <div>
          {documents
            .sort((a, b) => stringArraySort(a.image_file_name, b.image_file_name))
            .map((doc, index) => (
              <div key={index} className="row">
                <div className="col-sm-10" style={{ padding: 0 }}>
                  <h5>
                    <button
                      type="button"
                      className="link-button"
                      onClick={() => window.open(decodeURI(doc.url))}
                    >
                      {`${doc.type} - ${doc.sub_type} - ${doc.image_file_name}`}
                    </button>
                  </h5>
                </div>
                <div className="col-sm-2" style={{ padding: 0 }}>
                  {deleteTenantDocument && (
                    <IconButton
                      style={{
                        padding: '0px',
                        marginTop: '-7px',
                        verticalAlign: 'text-bottom',
                        width: 'none',
                        height: 'none',
                        float: 'right',
                      }}
                      onClick={() => deleteTenantDocument(doc.id)}
                    >
                      <DeleteIcon size={24} style={{ padding: 0 }} />
                    </IconButton>
                  )}
                </div>
              </div>
            ))}
        </div>
      ) : (
        <p style={{ color: '#7d7d7d' }}> No documents submitted </p>
      )}
    </div>
  );
};

export default TenantDocumentList;
